import angular from "angular";

angular
    .module('app')
    .component('individualCourseDemo', {
        template: require('./individual-course-demo.html'),
        controller: ['$http', 'Notifier', 'ErrorResponseParser', '$uibModal','moment', controller],
        bindings: {
            course: '<',
            inputParams: '<'
        }
    });

function controller($http, Notifier, ErrorResponseParser, $uibModal,moment) {
    let $ctrl = this;
    $ctrl.updateLoading = null;
    $ctrl.$onInit = function () {
        console.log($ctrl.course);
    };

    $ctrl.updateLessonDemoAccess = function (lesson) {
        if ($ctrl.updateLoading) {
            alert('Идет обновление. Повторите чуть позже');
            return;
        }

        $ctrl.updateLoading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/individual-training/demo/${lesson.id}/update-lesson-demo-access`, {
                open_for_demo: lesson.open_for_demo
            })
            .then(
                function () {
                    $ctrl.updateLoading = false;

                    Notifier.success('Успешно обновлен', 1);
                },
                function (error) {
                    $ctrl.updateLoading = false;
                    lesson.open_for_demo = !lesson.open_for_demo;
                    ErrorResponseParser.parse(error);
                    Notifier.error('Произошла ошибка:' + error.data.message, 2);
                }
            );
    }

    $ctrl.updateCourseDemoAccess = function () {
        if ($ctrl.updateLoading) {
            alert('Идет обновление. Повторите чуть позже');
            return;
        }
        $ctrl.updateLoading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/individual-training/demo/update-course-demo-access`, {
                allow_demo: $ctrl.course.allow_demo
            })
            .then(
                function () {
                    $ctrl.updateLoading = false;

                    Notifier.success('Успешно обновлено', 1);
                },
                function (error) {
                    $ctrl.updateLoading = false;
                    $ctrl.course.allow_demo = !ctrl.course.allow_demo;
                    ErrorResponseParser.parse(error);
                    Notifier.error('Произошла ошибка:' + error.data.message, 2);
                }
            );
    }
}
